import React from "react"
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles"
import SectionTitle from "../../../components/Typography/SectionTitle"
import SectionCategory from "../../../components/Typography/SectionCategory"
import { FormattedMessage } from "react-intl"
import ContentWrapper from "../../../components/Container/ContentWrapper"
import { Locale } from "../../../locale"
import SectionDescription from "../../../components/Typography/SectionDescription"
import usePlatform from "../../../hooks/usePlatform"
import TransitionDashboardImages from "./TransitionDashboardImages"
import useScrollImpressionLog from "../../../hooks/useScrollImpressionLog"

interface StyleProps {
  isDesktop: boolean
}
const useStyles = makeStyles<Theme, StyleProps>((theme: Theme) =>
  createStyles({
    root: {
      padding: "48px 20px",
      background: "#FFF",
      height: 560,
      [theme.breakpoints.up("md")]: {
        padding: "100px 0",
        height: 1239,
      },
    },
    bottomGradient: {
      marginTop: ({ isDesktop }) => (isDesktop ? "20%" : "10%"),
      width: "100%",
      height: 1265,
      background: "radial-gradient(50% 50% at 50% 50%, #E2EEFF 0%, rgba(226, 238, 255, 0) 100%)",
    },
  })
)
export default function DataInsight() {
  const { isDesktop } = usePlatform()
  const classes = useStyles({ isDesktop })
  const { lang } = Locale.getDefault()
  const { ref } = useScrollImpressionLog({
    message: "2_0: 몇 번의 클릭으로 사용자 행동 분석을 손쉽게!",
    eventKey: "homepage_data_analytics_detail_section_2_impression",
  })

  return (
    <div className={classes.root} ref={ref}>
      <ContentWrapper>
        <SectionCategory>Data Insight</SectionCategory>
        <SectionTitle>
          <FormattedMessage id={"analytics_detail_page_data_insight_title"} />
        </SectionTitle>
        {lang === "ko" ? (
          <SectionDescription>
            몇 번의 클릭으로 사용자 행동 로그를 시각화하여 분석할 수 있습니다.
            <br />
            사용자 유입, 전환율, 비즈니스 KPI 추이 등 고객의 제품 이용현황을 파악할 수 있습니다.
          </SectionDescription>
        ) : (
          <SectionDescription>
            You can visualize and analyze a user's behavior data in a few clicks.
            <br />
            Gain visibility into customer product usage, including user influx, conversion rate, and business KPI
            trends.
          </SectionDescription>
        )}
        <TransitionDashboardImages />
      </ContentWrapper>
      <div className={classes.bottomGradient} />
    </div>
  )
}
